export enum AddTuftProductViewMode {
  GENERAL,
  OPTIONAL_SETTINGS
}
